"use client";
import { getHostURL } from "../../helpers/envs";
import { useSearchParams } from "next/navigation";

export function useGetCallBackUrl(path?: string) {
  const search = useSearchParams();
  const callbackUrl = search.get("callbackUrl");
  const fallbackPath = path || "dashboard";
  const normalizedFallbackPath = fallbackPath.startsWith("/")
    ? fallbackPath.slice(1)
    : fallbackPath;

  return callbackUrl ?? `${getHostURL()}/${normalizedFallbackPath}`;
}
